var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBroadcastIconWithEffect = function SvgBroadcastIconWithEffect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193,
    height: 170,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#BroadcastIconWithEffect_svg__a)",
    d: "M147.489 85c0 36.8-26.171 45.412-51.233 45.412S45.023 121.8 45.023 85.001 71.195 39.59 96.256 39.59c25.062 0 51.233 8.612 51.233 45.41m-92.896 0c0 23.028 18.653 41.695 41.663 41.695s41.664-18.667 41.664-41.694-18.654-41.694-41.664-41.694-41.663 18.667-41.663 41.694"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#BroadcastIconWithEffect_svg__b)",
    d: "M168.448 84.998c0 51.896-36.878 64.041-72.192 64.041s-72.191-12.145-72.191-64.04 36.877-64.042 72.191-64.042 72.192 12.145 72.192 64.041m-130.899 0c0 32.474 26.284 58.799 58.707 58.799s58.707-26.325 58.707-58.799S128.679 26.2 96.256 26.2 37.55 52.524 37.55 85",
    opacity: 0.27
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#BroadcastIconWithEffect_svg__c)",
    d: "M192.511 85c0 68.88-49.17 85-96.255 85S0 153.88 0 85 49.17 0 96.256 0s96.255 16.12 96.255 85M17.979 85c0 43.102 35.046 78.042 78.277 78.042s78.276-34.94 78.276-78.042c0-43.101-35.045-78.042-78.276-78.042S17.979 41.898 17.979 85",
    opacity: 0.16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M95.867 79.126a5.877 5.877 0 1 0 0 11.754 5.877 5.877 0 0 0 0-11.754m0 9.897a4.02 4.02 0 1 1 0-8.041 4.02 4.02 0 0 1 0 8.041m12.062-4.02a12.02 12.02 0 0 1-3.071 8.041.93.93 0 0 1-1.296.057.926.926 0 0 1-.087-1.294 10.196 10.196 0 0 0 0-13.609.94.94 0 0 1-.25-.675.94.94 0 0 1 .308-.65.925.925 0 0 1 1.035-.138.9.9 0 0 1 .29.226 12.02 12.02 0 0 1 3.071 8.042M86.461 81.03a10.2 10.2 0 0 0 1.797 10.777.928.928 0 0 1-1.382 1.237 12.05 12.05 0 0 1 0-16.083.928.928 0 1 1 1.382 1.237 10.2 10.2 0 0 0-1.797 2.832m27.654 3.973a18.2 18.2 0 0 1-5.213 12.77.93.93 0 0 1-1.313.014.926.926 0 0 1-.014-1.313 16.374 16.374 0 0 0 0-22.943.9.9 0 0 1-.198-.303.926.926 0 0 1 1.225-1.2.9.9 0 0 1 .3.204 18.2 18.2 0 0 1 5.213 12.77M84.158 96.474a.928.928 0 1 1-1.326 1.3 18.236 18.236 0 0 1 0-25.542.928.928 0 1 1 1.326 1.3 16.374 16.374 0 0 0 0 22.942"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "BroadcastIconWithEffect_svg__a",
    x1: 96.256,
    x2: 96.256,
    y1: 39.59,
    y2: 130.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BroadcastIconWithEffect_svg__b",
    x1: 96.256,
    x2: 96.256,
    y1: 20.957,
    y2: 149.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BroadcastIconWithEffect_svg__c",
    x1: 96.256,
    x2: 96.256,
    y1: 0,
    y2: 170,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.3
  })))));
};
export default SvgBroadcastIconWithEffect;